var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAireGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5158 7.95772L3.30866 1C-0.553458 10.8873 4.41212 22.0563 14.5272 25.9013L32.5504 32.859C36.4125 22.9717 31.4469 11.8028 21.5158 7.95772Z",
    fill: "#004B2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6544 37.9856L47.6312 31.0278C43.7691 40.9151 48.7347 52.2672 58.6658 55.9291L76.689 62.8869C80.5512 52.9996 75.5856 41.8306 65.6544 37.9856Z",
    fill: "#004B2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.619 54.0987L20.5958 47.141C16.7337 57.0283 21.6992 68.1972 31.8143 72.0423L49.8375 79C53.6996 69.1127 48.734 57.7607 38.619 54.0987Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAireGreen);
export default __webpack_public_path__ + "static/media/aire-green.2fdcc92f12db852b7b10a16ea0419444.svg";
export { ForwardRef as ReactComponent };